import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly adminRole = 1;
  private readonly studentRole = 2;
  isLoggedIn: boolean = false;
  idstudent?: number;
  name?: string;
  lastname?: string;
  ci?: string;
  status?: number;
  userid?: number;
  username?: string;
  iduser?: number;
  rol?: number;

  constructor() {
    this.loadUserData();
    this.loadStudentData();
  }

  setLoggedIn(value: boolean) {
    this.isLoggedIn = value;
    localStorage.setItem('isLoggedIn', JSON.stringify(value));
  }

  hasToken(): boolean {
    const token = localStorage.getItem('token');
    return !!token && token.trim() !== '';
  }

  hasResolvedUser(): boolean {
    return !!this.iduser && this.rol !== undefined;
  }

  isActive(): boolean {
    return Number(this.status) === 1;
  }

  hasStudentContext(): boolean {
    return this.rol === this.studentRole && !!this.idstudent;
  }

  hasRole(allowedRoles: number[]): boolean {
    return this.rol !== undefined && allowedRoles.includes(this.rol);
  }

  canAccessProtectedRoutes(): boolean {
    return this.isLoggedIn && this.hasToken() && this.hasResolvedUser() && this.isActive();
  }

  getDefaultRoute(): string {
    if (this.rol === this.adminRole) {
      return '/student';
    }

    if (this.rol === this.studentRole) {
      return '/practiceinscription';
    }

    return '/login';
  }

  setStudentData(student: {
    idstudent?: number;
    userid?: number;
    name: string;
    lastname: string;
    ci: string;
    status: number;
  }) {
    this.idstudent = student.idstudent;
    this.userid = student.userid;
    this.name = student.name;
    this.lastname = student.lastname;
    this.ci = student.ci;
    this.status = student.status;

    const studentData = {
      idstudent: student.idstudent,
      userid: student.userid,
      name: student.name,
      lastname: student.lastname,
      ci: student.ci,
      status: student.status
    };
    localStorage.setItem('studentData', JSON.stringify(studentData));
  }

  getStudentData() {
    return {
      idstudent: this.idstudent,
      name: this.name,
      lastname: this.lastname,
      ci: this.ci,
      status: this.status,
      userid: this.userid
    };
  }

  setUserData(username: string, id: number,status:number, rol:number) {
    this.username = username;
    this.iduser = id;
    this.status = status;
    this.rol= rol;
    const userData = { username, id, status, rol };
    localStorage.setItem('userData', JSON.stringify(userData));
  }

  getUserData() {
    return {
      id: this.iduser,
      username: this.username,
      status: this.status,
      rol: this.rol
    };
  }

  private loadUserData() {
    const userData = localStorage.getItem('userData');
    if (userData) {
      const parsedData = JSON.parse(userData);
      this.username = parsedData.username;
      this.iduser = parsedData.id;
      this.status = parsedData.status;
      this.rol = parsedData.rol;
    }

    const isLoggedIn = localStorage.getItem('isLoggedIn');
    this.isLoggedIn = isLoggedIn === 'true';
  }

  private loadStudentData() {
    const studentData = localStorage.getItem('studentData');
    if (studentData) {
      const parsedData = JSON.parse(studentData);
      this.idstudent = parsedData.idstudent;
      this.userid = parsedData.userid;
      this.name = parsedData.name;
      this.lastname = parsedData.lastname;
      this.ci = parsedData.ci;
      this.status = parsedData.status;
    }
  }

  clearUserData() {
    localStorage.removeItem('userData');
    localStorage.removeItem('studentData');
    localStorage.removeItem('isLoggedIn');
    this.isLoggedIn = false;
    this.idstudent = undefined;
    this.name = undefined;
    this.lastname = undefined;
    this.ci = undefined;
    this.status = undefined;
    this.userid = undefined;
    this.username = undefined;
    this.iduser = undefined;
    this.rol = undefined;
  }

  clearSession() {
    localStorage.removeItem('token');
    this.clearUserData();
  }
}
